import {Service} from "platform/service/Service";
import {Reducer} from "platform/redux/Reducer";
import {ServiceType} from "enum/ServiceType";
import EduTradingEngine from "core/engine/EduTradingEngine";
import EduTradingReducer from "core/redux/eduTrading/EduTradingReducer";

export class EduTradingService implements Service<EduTradingEngine, any> {

    private static _instance: EduTradingService;

    private constructor() {
    }

    public static instance(): EduTradingService {
        return this._instance || (this._instance = new this());
    }

    public async setup<Props>(props?: Props): Promise<void> {
        await this.engine().setup();
    }

    public name(): string {
        return ServiceType.EduTrading;
    }

    public reducers(): Array<Reducer<any>> {
        return [EduTradingReducer.instance()];
    }

    public engine(): EduTradingEngine {
        return EduTradingEngine.instance();
    }

    public state(): any {
        return undefined;
    }
}
